import { render, staticRenderFns } from "./CompleteCourse.vue?vue&type=template&id=b312afee&scoped=true&"
import script from "./CompleteCourse.vue?vue&type=script&lang=js&"
export * from "./CompleteCourse.vue?vue&type=script&lang=js&"
import style0 from "./CompleteCourse.vue?vue&type=style&index=0&id=b312afee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b312afee",
  null
  
)

export default component.exports